import { isTemporalEmail } from 'utils/ValidationUtils';

/**
 * A client registered without an email address carries `<uuid>@temporal.cuddlesapp.com`, assigned by
 * the backend (`Customer` callbacks). The domain has no MX record, so anything sent there hard-bounces
 * against the SES account shared with email marketing — the backend refuses to deliver to it.
 *
 * The Inbox must not offer the Email channel for such a client, nor show the address as if it were
 * theirs. `isTemporalEmail` is the repo-wide check (checkout, invoices, tags); this only adds the
 * "treat it as no email at all" shape the Inbox needs.
 */
export const realEmail = (email?: string | null): string | undefined =>
    email && !isTemporalEmail(email) ? email : undefined;
